<template>
	<div class="layout">
		<div id="layout-title">
			<div id="layout-title-left">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon"/>
				待付款单据
			</div>
			<div id="layout-title-right">
			</div>
		</div>
		<div id="layout-box">
			<div id="box-search">
				<Form ref="formSearch" :label-width="70" :model="searchItems" inline>
					<FormItem label="单据号">
						<Input type="text" v-model="searchItems.listCode" placeholder="单据号"
							@keyup.enter.native="initListData(1)" />
					</FormItem>
					<div style="display:inline-block;" v-show="advancedSelect">
						<FormItem label="业务日期">
						    <DatePicker ref="searchBusinessDate"
						                type="daterange"
						                show-week-numbers
						                placement="bottom-end"
						                placeholder="请选择日期"
						                @on-change='businessDateChange'
						                style="width:100%">
						    </DatePicker>
						</FormItem>
						<FormItem label="业务伙伴">
							<Input type="text" v-model="searchItems.businessPeopleName" placeholder="业务伙伴"
								@keyup.enter.native="initListData(1)" />
						</FormItem>
					</div>
					<FormItem :label-width="20">
						<button class="jxyd-button jxyd-primary" @click="initListData(1)" style="margin-right:10px;">查询</button>
						<button class="jxyd-button" @click="initSearch" style="margin-right:10px;">重置</button>
						<span @click="advancedSelect = true;" style="color:red;cursor: pointer;" v-if="!advancedSelect">
							展开
							<Icon type="ios-arrow-down" size='18'/>
						</span>
						<span @click="foldSearch" style="color:red;cursor: pointer;" v-else>
							折叠
							<Icon type="ios-arrow-up" size='18'/>
						</span>
					</FormItem>
				</Form>
			</div>
			<div id="box-table">
				<Table row-key="guid" :columns="tableColumns" :data="listData"></Table>
			</div>
			<div id="page-box">
				<Page show-sizer :total="listCount" :page-size="searchItems.pageSize" @on-change="pageChange"
					show-total show-elevator :page-size-opts ='pageSizeOpts' :current="searchItems.pageIndex" @on-page-size-change='pageSizeChange'>
				</Page>
			</div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatDate from '@/utils/formatDate'

	export default {
		name: 'unpaidlist',
		components: {},
		data() {
			return {
				searchItems: {
					listCode: '',
					userId: parseInt(localStorage.getItem("userId")),
					userName:'',
					totalBusinessDate:[],
					businessPeopleName: '',
					sort:'1',
					pageSize: 10,
					pageIndex: 1,
				},
				listData:[],
				listCount:0,
				tableColumns: [
					{
						title: '单据编号',
						key: 'code',
						render:(h, params)=> {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										let router = {};
										switch(params.row.listType){
											case '采购单':
												router = {
													path: 'purchaselistdetail',
													query: {
														purchaseListCode: params.row.code
													}
												};
											break;
											case '其它付款单':
												router = {
													path: 'othercostlistdetail',
													query: {
														otherCostListCode: params.row.code
													}
												};
											break;
											case '销售退货单':
												router = {
													path: 'returnsaleslistdetail',
													query: {
														returnSalesListCode: params.row.code
													}
												};
											break;
											case '付款单':
												router = {
													path: 'paymentlistdetail',
													query: {
														paymentListCode: params.row.code
													}
												};
											break;
										}
										this.$router.push(router);
									}
								}
							}, " " + params.row.code)
						}
					},
					{
						title: '单据类型',
						key: 'listType',
						render:(h, params) => {
							return h('Tag', {
								style: {},
								attrs: {
									color: 'magenta'
								}
							}, params.row.listType);
						}
					},
					{
						title: '业务员',
						key: 'userDisplayName'
					},
					{
						title: '业务日期',
						key: 'businessDate',
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.businessDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '业务伙伴',
						key: 'businessPeopleName'
					},
					{
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						fixed: 'right',
						render: (h, params) => {
							return h('a', {
									class: 'jxyd-a',
									style: {
									},
									on: {
										click: (val) => {
											this.$router.push({
												path: 'paymentlistfunc',
												query: {
													list: params.row
												}
											});
										}
									}
								}, '付款')
						}
					}
				],
				advancedSelect: false,
				pageSizeOpts:[10,20,30,40,50,60,70,80,90,100]
			}
		},

		methods: {
			initListData(index) {
				let component = this;
				component.searchItems.pageIndex = index;
				request.post('/api/Home/GetUnPaidListByWeb', component.searchItems).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					component.listData = response.data.lists;
					component.listCount = response.data.count;
				}).catch(function(error) {})
			},
			pageChange(index) {
				this.initListData(index);
			},
			pageSizeChange(pageSize){
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			foldSearch() {
				this.advancedSelect = false;
				this.searchItems.userId = parseInt(localStorage.getItem("userId"));
				this.$refs.searchBusinessDate.handleClear();
				this.searchItems.businessPeopleName = '';
			},
			initSearch() {
				this.searchItems.listCode = '';
				this.searchItems.userId = parseInt(localStorage.getItem("userId"));
				this.$refs.searchBusinessDate.handleClear();
				this.searchItems.businessPeopleName = '';
			},
			businessDateChange(val) {
				if (val[0]) {
					this.searchItems.totalBusinessDate = val;
				} else {
					this.searchItems.totalBusinessDate = [];
				}
			},
			pageSizeChange(pageSize){
				this.searchItems.pageSize = pageSize;
				this.initListData(1);
			},
			pageChange(index) {
				this.initListData(index);
			}
		},
		watch: {},
		created: function() {
			this.initListData(1);
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	#layout-title {
		overflow: hidden;
		padding: 5px;
		font-size: 16px;
		border-bottom: 1px solid #e8eaec;
	}

	#box-search {
		padding-top: 20px;
	}

	#layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#layout-title-right {
		float: right;
	}

	#page-box {
		margin-top: 20px;
		text-align: center;
	}
</style>